import FieldErrorList from 'Components/FieldErrorList'
import { Box } from '@mui/material'
import type { FC, ReactNode } from 'react'

export interface ErrorType {
  message: string
  code: string
}

export type ErrorFields<T> = {
  [P in keyof T]: ErrorType[]
}

interface FieldErrorsProps {
  error: ErrorType[] | []
  identifier?: string | null
}

const FieldErrors: FC<FieldErrorsProps> = ({ error, identifier = null }) => {
  let errors: ReactNode
  if (Array.isArray(error) && error.length > 0) {
    errors = (
      <FieldErrorList>
        {error.map((err: ErrorType) => (
          <>
            {typeof err === 'string' ? (
              <li key={identifier ?? err}>{err}</li>
            ) : (
              <li key={identifier ?? err.code}>{err.message}</li>
            )}
          </>
        ))}
      </FieldErrorList>
    )
  }
  return <Box>{errors}</Box>
}

export default FieldErrors
